module.exports = __webpack_public_path__ + "static/media/plaque-psoriasis-elbow.7aa3330f.svg";